import { Conversation } from "@/pages/Private/pages/Apollo/schema/get-people";

import { buildReplySubject } from "./replySubject";

/**
 * Email conversation `type` values that carry an inheritable subject line. Mirrors the backend
 * `EMAIL_CONVERSATION_TYPES` (apps/api/src/schedule/constants.ts) that
 * `EmailReplyContextService.resolveSubject` uses when resolving a follow-up's subject.
 */
const EMAIL_SUBJECT_TYPES = ["mail_sent", "mail_received"];

const hasInheritableSubject = (conversation: Conversation): boolean =>
	EMAIL_SUBJECT_TYPES.includes(conversation.type) && !!conversation.subject?.trim();

const byMostRecent = (a: Conversation, b: Conversation): number =>
	new Date(b.sentAt).getTime() - new Date(a.sentAt).getTime();

/**
 * The "Re: …" subject a freshly-opened inbox reply inherits from the lead's most recent email
 * conversation that carries a subject. Frontend mirror of the backend
 * `EmailReplyContextService.resolveSubject`, so the composer shows exactly the subject the backend
 * would send for the reply (PREC-3094). Returns "" for the LinkedIn channel (no subject line) or
 * when nothing is inheritable — the composer then stays blank and prompts for one.
 */
export const resolveInboxReplySubject = (
	conversations: Conversation[],
	channelType: "email" | "linkedin" | undefined
): string => {
	if (channelType !== "email") {
		return "";
	}

	const latestWithSubject = conversations.filter(hasInheritableSubject).sort(byMostRecent)[0];

	return latestWithSubject?.subject ? buildReplySubject(latestWithSubject.subject) : "";
};
